var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export default class TinyMCEMenuService {
    /**
     * Gets the menu items for tthe Application Receipt Confirmation Configuration
     *
     */
    static getApplicationReceiptConfirmationMenu() {
        return __awaiter(this, void 0, void 0, function* () {
            // Ideally we shouldn't be hardcoding the values for the menu items as these
            // refer specifically to values defined on the server.  However, for now, this
            // will be left as a todo
            // TODO load in values from the server so they're not hardcoded.
            return [
                {
                    text: "Student First Name",
                    value: "studentFirstName",
                },
                {
                    text: "Student Last Name",
                    value: "studentLastName",
                },
                {
                    text: "Student Full Name",
                    value: "studentFullName",
                },
            ];
        });
    }
}
